import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import "./css/site.css";
import Moment from "moment";
import Vue from "vue";
import router from "./router/index";
import store from "./store";
import App from "./components/app-root";
import { action } from "./store/types";
import Vuetify from "vuetify";
import httpClient from "./store/httpClient";
import VueTheMask from "vue-the-mask";

Vue.use(Vuetify, {
	theme: {
		primary: "#aaa",
		secondary: "#efbb20",
		accent: "#efbb20",
		error: "#b71c1c",
	},
});

Vue.use(VueTheMask);

Vue.filter("formatDigit", function (value) {
	if (value) {
		return value.toFixed(2);
	} else {
		return "-";
	}
});
Vue.filter("formatInteger", function (value) {
	if (value) {
		return value.toFixed(0);
	} else {
		return "-";
	}
});
Vue.filter("formatLiefertermin", function (value) {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY [15:00 Uhr]");
	}
});
Vue.filter("formatDate", function (value) {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY");
	}
});
Vue.filter("formatDateAndTime", function (value) {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY HH:mm [Uhr]");
	}
});
Vue.filter("formatReceivedAt", function (value) {
	if (value) {
		return Moment(String(value)).format("[Empfangen am: ]DD.MM.YYYY HH:mm [Uhr]");
	}
});
Vue.filter("formatTechnicalDateAndTime", function (value) {
	if (value) {
		return Moment(String(value)).format("DD.MM.YYYY HH:mm:ss");
	}
});

console.log("Environment: " + process.env.NODE_ENV);
console.log("Staging: " + process.env.IS_TEST);

store
	.dispatch(action.BOOTSTRAP)
	.then(async () => {
		// router.push({ name: 'home' })
		console.log("Successfully bootstrapt application");

		try {
			let response = await httpClient().get(`api/Fertiger/GetFertigers`);
			console.log("Loaded Fertiger successfully");
			store.commit("setFertigers", response.data);
		} catch (err) {
			console.log(err);
		}

		try {
			let response = await httpClient().get(`api/Delivery/GetTransportProvider`);
			console.log("Loaded Transport provider successfully");
			store.commit("setTransportProvider", response.data);
		} catch (err) {
			console.log(err);
		}

		const app = new Vue({
			el: "#app",
			store,
			router,
			render: (h) => h(App),
		});
	})
	.catch((e) => console.log(e));
